import styled from '@emotion/styled'
import { css } from '@emotion/react'

const carouselStyle = ({ theme }) => css`
  label: carousel_container;

  display: grid;
  gap: 5px;
  grid-template-columns: repeat(2, 50%);

  ${theme.media.kilo} {
    gap: 8px;
    grid-template-columns: repeat(3, 1fr);
  }

  ${theme.media.giga} {
    gap: 8px;
    grid-template-columns: repeat(4, 1fr);
  }
`

export const Carousel = styled('ul')(carouselStyle)

const carouseItemStyle = () => css`
  label: carousel_container;

  & > div {
    width: 100%;
  }
`

export const CarouseItem = styled('li')(carouseItemStyle)
